(function() {
    'use strict';

    calculatorService.$inject = ['$http', '$q'];
    angular
        .module('app.calculator')
        .factory('calculatorService', calculatorService);

    /* @ngInject */
    function calculatorService($http, $q) {
        var isPrimed = false;
        var primePromise;

        var service = {
            ready: ready,
            getProducts: getProducts,
            createFormRecord: createFormRecord
        };

        return service;

    
        function getProducts(pageId, productIds) {
            return $http.get('/umbraco/api/calculator/getproducts?productIds='+ productIds +'&pageid=' +pageId)
                .then(function (response) {
                    if (response.data) {
                        return response.data;
                    }
                    return null;
                });
        };

        function createFormRecord(model) {
            model.productName = model.product.name;
            model.productId = model.product.id;
            model.productUrl = 'https://www.radacontrols.com'+model.product.url;
            model.productImage = 'https://www.radacontrols.com'+model.product.image;
            model.productDescription = model.product.description;
            return $http.post('/umbraco/api/calculator/createformrecord', model, {
                headers: { "Content-Type": "application/json; charset=UTF-8" }
            })
                .then(function () {
                    
                });
        };

        function prime() {
            if (primePromise) {
                return primePromise;
            }

            primePromise = $q.when(true).then(success);
            return primePromise;

            function success() {
                isPrimed = true;
                logger.info('Primed data');
            }
        };

        function ready(nextPromises) {
            var readyPromise = primePromise || prime();

            return readyPromise
                .then(function() { return $q.all(nextPromises); })
                .catch(exception.catcher('"ready" function failed'));
        };
    }
})();